export default __webpack_public_path__ + "static/media/Handguards of Vernant Fury.a03e5e53.jpg";